
import { useTranslation } from 'react-i18next';
import TitleText from '../../atoms/TitleText';
import { Link, useLocation } from 'react-router-dom';
import InfoText from '../../atoms/InfoText';
import { SellerProductBasicDetails } from './types';
import ProductActions from './ProductActions';

type Props = {
  productId: string;
  basicDetails?: SellerProductBasicDetails;
  loading: boolean;
};

export default function ProductDetailsBreadcrumbs({
  productId,
  basicDetails,
  loading,
}: Props) {
  const { t } = useTranslation();
  const location = useLocation();
  const sellerId = location.state?.sellerId;

  return (
    <div
      className="flex flex-col sm:flex-row sm:items-center justify-between w-full gap-4"
      data-testid="seller-product-details-breadcrumbs"
    >
      <div
        className="flex flex-col gap-1"
        data-testid="seller-product-breadcrumbs-left"
      >
        <TitleText
          text={t('productDetailsTitle')}
          size="xl"
          className="!font-bold !text-gray-900 dark:!text-white !text-3xl"
        />
        <div
          className="flex items-center gap-2 text-base flex-wrap mt-1"
          data-testid="seller-product-breadcrumbs-nav"
        >
          <Link to="/" data-testid="seller-product-breadcrumb-home">
            <InfoText
              text={t('product.dashboard')}
              className="!text-gray-500 hover:!text-gray-900 dark:hover:!text-gray-200 transition-colors"
            />
          </Link>
          <InfoText text="/" className="!text-gray-400" />
          <Link to={sellerId ? `/sellers/${sellerId}/profile` : "/products"} state={sellerId ? { activeTab: 'products' } : undefined} data-testid="seller-product-breadcrumb-list">
            <InfoText
              text={t('product.productsList')}
              className="!text-gray-500 hover:!text-gray-900 dark:hover:!text-gray-200 transition-colors"
            />
          </Link>

          <InfoText text="/" className="!text-gray-400" />

          {!loading && basicDetails?.productName && (
            <InfoText
              text={basicDetails.productName}
              className="!text-gray-800 dark:!text-gray-200 !font-normal"
            />
          )}
        </div>
      </div>

      <div
        className="flex items-center"
        data-testid="seller-product-breadcrumbs-actions"
      >
        <ProductActions basicDetails={basicDetails} productId={productId} />
      </div>
    </div>
  );
}
